export default __webpack_public_path__ + "static/garden_design6-e6fd577246d18e339c853e6d79c358fb.webp";